var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("import-references")))]),
      _vm.importReferencedSales.length == 0
        ? _c("w-card-content", [
            _vm._v(" " + _vm._s(_vm.$ct("no-import-references")) + " "),
          ])
        : _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.importReferencedSales, function (item) {
              return _c(
                "w-list-item",
                {
                  key: item.ID,
                  on: {
                    click: function ($event) {
                      return _vm.openSale(item.ID)
                    },
                  },
                },
                [
                  _c("w-list-item-text", [
                    _c(
                      "span",
                      { staticClass: "timestamp" },
                      [
                        _c("app-timeago", {
                          staticClass: "date",
                          attrs: { datetime: item.InvoiceDate },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$ct("loaded-in")) +
                        " " +
                        _vm._s(item.Type.Name.getTranslation()) +
                        " " +
                        _vm._s(item.ComputedFriendlyID) +
                        " "
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }